import { z } from 'zod'

/***************** 택배사 *****************/
export const DELIVERY_COMPANY = ['CJ', 'LOGEN', 'HANJIN', 'POST', 'LOTTE'] as const

export const DeliveryCompanySchema = z.enum(DELIVERY_COMPANY)
export type DeliveryCompany = z.infer<typeof DeliveryCompanySchema>
